import { HandleType } from '@xyflow/react'

export const parseNodeHandleId = (
  id: string
): { nodeId: string; type: HandleType; handleMapping: string | undefined } => {
  const [nodeId, type, handleMapping] = id.split(':')

  return {
    nodeId,
    type: type as HandleType,
    handleMapping
  }
}
